<div class="">
  <div class="ttm-page-title-row ttm-bgcolor-whiteecolor">
    <div class="ttm-page-title-row-bg-layer ttm-bg-layer"></div>
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="title-box">
            <div class="page-title-heading text-white">
              <h1 class="title text-white">Gallery</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="row mt-3" *ngIf="!hideRow">
    <div class="col-lg"></div>
    <div class="row mt-3">
      <div class="row ">
        <div class="col-lg">
          <div class="card border">
            <div class="gallery-grid">
              <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
                <div class="featured-thumbnail">
                  <img src="assets/img/campus1.jpeg" alt="" class="img-fluid imghvr-zoom-in"
                    (click)="GetHomeFuction('CAMPUS')">
                  <h1 class="text-center mt-2">CAMPUS</h1>
                </div>
              </div>
            </div>
            <figcaption class="card-img-overlay pos-center text-center">
              <div class="center-holder">
                <a href="javascript:void(0)" class="square-40 circle bg-light shadow-box border"><i class="fa fa-search"
                    (click)="GetHomeFuction('CAMPUS')"></i></a>
              </div>
            </figcaption>
          </div>
        </div>
        <div class="col-lg">
          <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
            <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
              <div class="featured-thumbnail">
                <img src="assets/img/campus16.jpg" alt="" class="img-fluid" (click)="GetHomeFuction('Accommodation')">
                <h1 class="text-center mt-2">Accommodation</h1>
              </div>
            </div>
          </div>
          <figcaption class="card-img-overlay pos-center text-center">
            <div class="center-holder">
              <a href="javascript:void(0)" class="square-40 circle bg-light shadow-box border"><i class="fa fa-search"
                  (click)="GetHomeFuction('Accommodation')"></i></a>
            </div>
          </figcaption>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3 " *ngIf="!hideRow">
    <div class="col-lg">
      <div class="gallery-grid">
        <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
          <div class="featured-thumbnail">
            <img src="assets/img/TreamentF9.jpeg" alt="" class="img-fluid" (click)="GetHomeFuction('FemaleT')">
            <h1 class="text-center mt-2"> Treament Center-Female Dept </h1>
            <figcaption class="card-img-overlay pos-center text-center">
              <div class="center-holder">
                <a href="javascript:void(0)" class="square-40 circle bg-light shadow-box border"><i class="fa fa-search"
                    (click)="GetHomeFuction('FemaleT')"></i></a>
              </div>
            </figcaption>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg">
      <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
        <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
          <div class="featured-thumbnail">
            <img src="assets/img/TreamentF6.jpeg" alt="" class="img-fluid" (click)="GetHomeFuction('MaleT')">
            <h1 class="text-center mt-2"> Treament Center-Male Dept </h1>
            <figcaption class="card-img-overlay pos-center text-center">
              <div class="center-holder">
                <a href="javascript:void(0)" class="square-40 circle bg-light shadow-box border"><i class="fa fa-search"
                    (click)="GetHomeFuction('MaleT')"></i></a>
              </div>
            </figcaption>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3" *ngIf="!hideRow">
    <div class="col-lg">
      <div class="gallery-grid">
        <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
          <div class="featured-thumbnail">
            <img src="assets/img/Yoga1.jpeg" alt="" class="img-fluid" (click)="GetHomeFuction('yoga')">
            <h1 class="text-center mt-2"> Yoga-Yogacharyas </h1>
            <figcaption class="card-img-overlay pos-center text-center">
              <div class="center-holder">
                <a href="javascript:void(0)" class="square-40 circle bg-light shadow-box border"><i class="fa fa-search"
                    (click)="GetHomeFuction('yoga')"></i></a>
              </div>
            </figcaption>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg">
      <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
        <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
          <div class="featured-thumbnail">
            <img src="assets/img/team1.jpeg" alt="" class="img-fluid" (click)="GetHomeFuction('team')">
            <h1 class="text-center mt-2">Our Team</h1>
            <figcaption class="card-img-overlay pos-center text-center">
              <div class="center-holder">
                <a href="javascript:void(0)" class="square-40 circle bg-light shadow-box border"><i class="fa fa-search"
                    (click)="GetHomeFuction('team')"></i></a>
              </div>
            </figcaption>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3" *ngIf="!hideRow">
    <div class="row">
      <div class="col-lg">
        <div class="gallery-grid">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img src="assets/img/OnlineBook5.jpg" alt="" class="img-fluid" (click)="GetHomeFuction('book')">
              <h1 class="text-center mt-2"> Online Book Store </h1>
              <figcaption class="card-img-overlay pos-center text-center">
                <div class="center-holder">
                  <a href="javascript:void(0)" class="square-40 circle bg-light shadow-box border"><i
                      class="fa fa-search" (click)="GetHomeFuction('book')"></i></a>
                </div>
              </figcaption>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg">
        <div class="featured-imagebox featured-imagebox-team ttm-team-box-view-overlay-style2 mb-30">
          <div class="ttm-box-view-overlay ttm-team-style2-box-view-overlay">
            <div class="featured-thumbnail">
              <img src="assets/img/PhysiotherapyA4.jpeg" alt="" class="img-fluid"
                (click)="GetHomeFuction('Physiotherapy')">
              <h1 class="text-center mt-2"> Physiotherapy & Acupuncture- Electrotherapy </h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <div class="container py-5" *ngIf="!hideRow">
    <div class="row g-4">
      <div class="col-sm-6 col-lg-4 col-xl-3 mt-2" *ngFor="let card of galleryCards">
        <div class="card gallery-card h-100 shadow-lg border-0 overflow-hidden"
          (click)="GetHomeFuction(card.type,card.title)">

          <!-- Image -->
          <div class="gallery-img-wrapper">
            <img [src]="card.img" class="card-img-top img-fluid" alt="{{card.title}}">
            <div class="gallery-overlay d-flex justify-content-center align-items-center">
              <button class="btn btn-light btn-circle">
                <i class="fa fa-search text-dark"></i>
              </button>
            </div>
          </div>

          <!-- Title -->
          <div class="card-body text-center">
            <h5 class="card-title fw-bold">{{card.title}}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- campus-gallery.component.html -->
  <!-- <div class="container mt-4" *ngIf="iscampus">
    <div class="chk-block-content">
      <div class="row">
        <div class="col-sm-6 col-lg-6 col-xl-3 mb-3" *ngFor="let user of campus">
          <div class="card border gallery-card">
            <figure class="imghvr-zoom-in">
              <img [src]="user.image" class="img-fluid" alt="campus image" (click)="openImage(user.image)">
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <!-- Campus Images Section -->
  <!-- <div class="container py-5" *ngIf="iscampus">
    <div class="mb-4">
      <button class="btn btn-outline-primary btn-lg rounded-pill shadow-sm" (click)="goBack()">
        <i class="fa fa-arrow-left me-2"></i> Back
      </button>
    </div>

    <h2 class="fw-bold text-center mb-4 text-primary">Campus Gallery</h2>

    <div class="row g-4">
      <div class="col-sm-6 col-lg-4 col-xl-3 mt-2" *ngFor="let user of campus">
        <div class="card gallery-card border-0 shadow-lg h-100 overflow-hidden">
          <div class="gallery-img-wrapper">
            <img [src]="user.image" class="card-img-top img-fluid" alt="campus image" (click)="openImage(user.image)">
            <div class="gallery-overlay d-flex justify-content-center align-items-center">
              <button class="btn btn-light btn-circle" (click)="openImage(user.image)">
                <i class="fa fa-search text-dark"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

  <!---Accommodation-->
  <!-- <div class="container mt-4" *ngIf="isAccommodation">
    <div class="chk-block-content">
      <div class="row">
        <div class="col-sm-6 col-lg-6 col-xl-3 mb-3" *ngFor="let user of Accommodation">
          <div class="card border gallery-card">
            <figure class="imghvr-zoom-in">
              <img [src]="user.image" class="img-fluid" alt="Accommodation image" (click)="openImage(user.image)">
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!---TreatmentFemale-->
  <!-- <div class="container mt-4" *ngIf="isTreatmentFemale">
    <div class="chk-block-content">
      <div class="row">
        <div class="col-sm-6 col-lg-6 col-xl-3 mb-3" *ngFor="let user of TreatmentFemale">
          <div class="card border gallery-card">
            <figure class="imghvr-zoom-in">
              <img [src]="user.image" class="img-fluid" alt="Treatment Female image" (click)="openImage(user.image)">
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!---TreatmentMale-->
  <!-- <div class="container mt-4" *ngIf="isTreatmentMale">
    <div class="chk-block-content">
      <div class="row">
        <div class="col-sm-6 col-lg-6 col-xl-3 mb-3" *ngFor="let user of TreatmentMale">
          <div class="card border gallery-card">
            <figure class="imghvr-zoom-in">
              <img [src]="user.image" class="img-fluid" alt="Treatment Male image" (click)="openImage(user.image)">
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!---yoga-->
  <!-- <div class="container mt-4" *ngIf="isYoga">
    <div class="chk-block-content">
      <div class="row">
        <div class="col-sm-6 col-lg-6 col-xl-3 mb-3" *ngFor="let user of yoga">
          <div class="card border gallery-card">
            <figure class="imghvr-zoom-in">
              <img [src]="user.image" class="img-fluid" alt="yoga image" (click)="openImage(user.image)">
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!---Physiotherapy-->
  <!-- <div class="container mt-4" *ngIf="isPhysiotherapy">
    <div class="chk-block-content">
      <div class="row">
        <div class="col-sm-6 col-lg-6 col-xl-3 mb-3" *ngFor="let user of Physiotherapy">
          <div class="card border gallery-card">
            <figure class="imghvr-zoom-in">
              <img [src]="user.image" class="img-fluid" alt="Physiotherapy image" (click)="openImage(user.image)">
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!---OnlineBook-->
  <!-- <div class="container mt-4" *ngIf="isOnlinebook ">
    <div class="chk-block-content">
      <div class="row">
        <div class="col-sm-6 col-lg-6 col-xl-3 mb-3" *ngFor="let user of book">
          <div class="card border gallery-card">
            <figure class="imghvr-zoom-in">
              <img [src]="user.image" class="img-fluid" alt="book image" (click)="openImage(user.image)">
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div> -->
  <!---OurTeam-->
  <!-- <div class="container mt-4" *ngIf="isOurteam ">
    <div class="chk-block-content">
      <div class="row">
        <div class="col-sm-6 col-lg-6 col-xl-3 mb-3" *ngFor="let user of team">
          <div class="card border gallery-card">
            <figure class="imghvr-zoom-in">
              <img [src]="user.image" class="img-fluid" alt="team image" (click)="openImage(user.image)">
            </figure>
          </div>
        </div>
      </div>
    </div>
  </div> -->
</div>


<!-- ================================================================================================================================================================================================= -->

<div class="container py-5" *ngIf="activeCategory">
  <!-- Back Button -->
  <div class="mb-4">
    <button class="btn btn-outline-primary btn-lg rounded-pill shadow-sm" (click)="goBack()">
      <i class="fa fa-arrow-left me-2"></i> Back
    </button>
  </div>

  <!-- Title -->
  <h2 class="fw-bold text-center mb-4 text-primary">
    {{ Title }}
  </h2>

  <!-- Image Grid -->
  <div class="row g-4">
    <div class="col-sm-6 col-lg-4 col-xl-3 mt-2" *ngFor="let user of galleries[activeCategory]; let i = index">
      <div class="card gallery-card border-0 shadow-lg h-100 overflow-hidden" (click)="openImage(user.image, i)">
        <div class="gallery-img-wrapper">
          <img [src]="user.image" class="card-img-top img-fluid" alt="{{activeCategory}} image">
          <div class="gallery-overlay d-flex justify-content-center align-items-center">
            <button class="btn btn-light btn-circle" (click)="openImage(user.image, i)">
              <i class="fa fa-search text-dark"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Fullscreen Modal -->
<!-- <div class="modal fade show" tabindex="-1" *ngIf="selectedImage" style="display:block; background:rgba(0,0,0,0.85);">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content bg-transparent border-0">
      <div class="modal-body d-flex justify-content-center align-items-center p-0 fullscreen-body">
        <img [src]="selectedImage" class="fullscreen-img" alt="fullscreen image">
      </div>
    </div>
  </div>
  <button class="btn btn-light close-btn" (click)="closeImage()">✕</button>
</div> -->

<!-- Fullscreen Modal -->
<div class="modal fade show" tabindex="-1" *ngIf="selectedImage" style="display:block; background:rgba(0,0,0,0.85);">
  <div class="modal-dialog modal-fullscreen">
    <div class="modal-content bg-transparent border-0">
      <div class="modal-body d-flex justify-content-center align-items-center p-0 fullscreen-body">

        <!-- Prev Button (Left side) -->
        <button class="btn btn-dark prev-btn" (click)="prevImage()">❮</button>

        <!-- Image -->
        <img [src]="selectedImage" class="fullscreen-img" alt="fullscreen image">

        <!-- Next Button (Right side) -->
        <button class="btn btn-dark next-btn" (click)="nextImage()">❯</button>

      </div>
    </div>
  </div>
  <button class="btn btn-light close-btn position-absolute top-0 end-0 m-3" (click)="closeImage()">✕</button>
</div>